import { UserDialog } from '@prismamedia/one-components';
import { RawUser } from '@prismamedia/one-user';
import { CalendarPage } from 'pages/CalendarPage';
import { ComponentType, FC } from 'react';
import {
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps,
  Switch,
} from 'react-router-dom';
import { getUsers } from './apollo/queries/users.auth.graphql';
import { CampaignPage } from './pages/CampaignPage';
import { DuplicatePage } from './pages/CampaignPage/DuplicatePage';
import { LoginPage } from './pages/Login';
import { AzureCallback } from './pages/Login/AzureCallback';
import { NewsletterPage } from './pages/NewsletterPage';
import { auth } from './utils/auth';
import { useLocationChange } from './utils/useLocationChange';

export const replaceParams = (
  path: string,
  params: Record<string, string>,
): string => {
  const keys = Object.entries(params);
  let newPath = path;
  keys.forEach((k) => {
    newPath = newPath.replace(`:${k[0]}`, k[1]);
  });
  return newPath.replace(/\(.*\)/, '');
};

export enum paths {
  LOGIN = '/login',
  LOGIN_AZURE_CALLBACK = '/login/azure/callback',
  CALENDAR = '/calendar',
  CAMPAIGN_LIST = '/campaign/list',
  CAMPAIGN_EDIT = '/campaign/:id',
  CAMPAIGN_NEW = '/campaign/new',
  CAMPAIGN_UNLOCK = '/campaign/unlock/:id',
  DUPLICATE_CAMPAIGN = '/duplicate/:id',
  NEWSLETTER_LIST = '/template/list',
  NEWSLETTER_NEW = '/template/new',
  NEWSLETTER_EDIT = '/template/:id',
}

type PrivateRouteProps = {
  component: ComponentType<RouteComponentProps>;
} & RouteProps;

const PrivateRoute = ({ component: Component, ...rest }: PrivateRouteProps) => (
  <Route
    {...rest}
    render={(props) =>
      auth.isAuthenticated() ? (
        <>
          <Component {...props} />
          <UserDialog
            auth={auth}
            searchUsers={getUsers as (query: string) => Promise<RawUser[]>}
          />
        </>
      ) : (
        <Redirect to={{ pathname: paths.LOGIN }} />
      )
    }
  />
);

export const Routing: FC = () => {
  useLocationChange();

  return (
    <Switch>
      <Route
        exact
        path={paths.LOGIN_AZURE_CALLBACK}
        component={AzureCallback}
      />
      <Route exact path={paths.LOGIN} component={LoginPage} />
      <PrivateRoute path="/campaign" component={CampaignPage} />
      <PrivateRoute path="/duplicate" component={DuplicatePage} />
      <PrivateRoute path="/template" component={NewsletterPage} />
      <PrivateRoute path={paths.CALENDAR} component={CalendarPage} />
      <PrivateRoute component={() => <Redirect to={paths.CAMPAIGN_LIST} />} />
    </Switch>
  );
};
